import { useState } from "react";
import { PanelNav } from "../Bootoverlay/Bootoverlay";
import SignalBoostModal from "./SignalBoostModal";

const ACHIEVEMENTS = [
  {
    id: "ACH-01",
    icon: "🔓",
    name: "FIRST CONTACT",
    desc: "Registered your callsign",
    xp: "+50 XP",
    unlocked: true,
    rarity: "COMMON",
  },
  {
    id: "ACH-02",
    icon: "🏆",
    name: "STRIP SLAYER",
    desc: "CLASSIFIED",
    xp: "??? XP",
    unlocked: false,
    rarity: "RARE",
  },
  {
    id: "ACH-03",
    icon: "👻",
    name: "NEON GHOST",
    desc: "CLASSIFIED",
    xp: "??? XP",
    unlocked: false,
    rarity: "EPIC",
  },
  {
    id: "ACH-04",
    icon: "⚔️",
    name: "FIRST BLOOD",
    desc: "CLASSIFIED",
    xp: "??? XP",
    unlocked: false,
    rarity: "RARE",
  },
  {
    id: "ACH-05",
    icon: "🚗",
    name: "CONVOY LEAD",
    desc: "CLASSIFIED",
    xp: "??? XP",
    unlocked: false,
    rarity: "LEGENDARY",
  },
  {
    id: "ACH-06",
    icon: "🦅",
    name: "DESERT HAWK",
    desc: "CLASSIFIED",
    xp: "??? XP",
    unlocked: false,
    rarity: "EPIC",
  },
];

const RARITY_COLORS = {
  COMMON:    { color: "#a3e635", glow: "rgba(163,230,53,0.3)" },
  RARE:      { color: "#00D4FF", glow: "rgba(0,212,255,0.3)" },
  EPIC:      { color: "#b06ef3", glow: "rgba(176,110,243,0.3)" },
  LEGENDARY: { color: "#FF8C00", glow: "rgba(255,140,0,0.35)" },
};

export default function PanelMissions({ onNav, broadcasts = 0, drivers = 0 }) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section className="vk-panel vk-missions-panel" id="panel-missions">

        {/* ── Ambient BG ── */}
        <div className="vk-ach-bg" aria-hidden="true">
          <div className="vk-ach-grid-lines" />
          <div className="vk-ach-scanlines" />
          <div className="vk-ach-g1" />
          <div className="vk-ach-g2" />
          <div className="vk-ach-g3" />
        </div>

        {/* ── Header ── */}
        <div className="vk-panel-header">
          <div className="vk-section-eyebrow">
            <span className="vk-eyebrow-num">06</span>
            <span>//</span>
            <span>Achievement Vault</span>
          </div>
          <h2 className="vk-section-title">
            ESTABLISH <br/> YOUR <span className="orange">RANK</span>
          </h2>
          <p className="vk-section-sub">
            Every action builds your driver record. Register, complete missions,
            and climb the leaderboard before launch.
          </p>
        </div>

        {/* ── Achievement Cards ── */}
        <div className="vk-ach-section">
          <div className="vk-ach-section-label">
            DRIVER ACHIEVEMENTS — 1 OF 6 UNLOCKED
          </div>

          <div className="vk-achieve-grid">
            {ACHIEVEMENTS.map((a, i) => {
              const rarityStyle = RARITY_COLORS[a.rarity];
              return (
                <div
                  key={a.id}
                  className={`vk-achieve-card${a.unlocked ? " unlocked" : " locked"}`}
                  style={{ animationDelay: `${i * 0.07}s` }}
                  // ── Only unlocked cards open the modal ──
                  onClick={a.unlocked ? () => setModalOpen(true) : undefined}
                  title={a.unlocked ? "View your Mission Card" : undefined}
                >
                  <div className="vk-ac-bg" />

                  {a.unlocked && (
                    <>
                      <div className="vk-ac-corner vk-ac-tl" />
                      <div className="vk-ac-corner vk-ac-br" />
                      <div
                        className="vk-achieve-glow"
                        style={{
                          background: `radial-gradient(ellipse at 50% 30%, ${rarityStyle.glow} 0%, transparent 65%)`,
                        }}
                      />
                    </>
                  )}

                  {/* Rarity pip */}
                  <div
                    className="vk-achieve-rarity"
                    style={
                      a.unlocked
                        ? { color: rarityStyle.color, borderColor: rarityStyle.color + "55" }
                        : {}
                    }
                  >
                    {a.unlocked ? a.rarity : "???"}
                  </div>

                  <div
                    className={`vk-achieve-icon-wrap${a.unlocked ? "" : " locked-ic"}`}
                    style={
                      a.unlocked
                        ? {
                            border: `1px solid ${rarityStyle.color}55`,
                            boxShadow: `0 0 20px ${rarityStyle.glow}, inset 0 0 12px ${rarityStyle.glow}55`,
                          }
                        : {}
                    }
                  >
                    {a.unlocked ? (
                      <span className="vk-achieve-icon">{a.icon}</span>
                    ) : (
                      <span className="vk-achieve-classified-icon">✕</span>
                    )}
                  </div>

                  <div className={`vk-achieve-name${a.unlocked ? "" : " classified"}`}>
                    {a.unlocked ? a.name : "CLASSIFIED"}
                  </div>

                  <div className={`vk-achieve-desc${a.unlocked ? "" : " classified"}`}>
                    {a.desc}
                  </div>

                  <div
                    className={`vk-achieve-xp${a.unlocked ? "" : " dim"}`}
                    style={
                      a.unlocked
                        ? {
                            color: rarityStyle.color,
                            borderColor: rarityStyle.color + "55",
                            background: rarityStyle.color + "11",
                          }
                        : {}
                    }
                  >
                    {a.xp}
                  </div>

                  {/* Unlocked: show share hint */}
                  {a.unlocked && (
                    <div className="vk-achieve-share-hint">
                      <span>◈ SHARE</span>
                    </div>
                  )}

                  {!a.unlocked && (
                    <div className="vk-achieve-stamp">
                      <span>CLASSIFIED</span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <PanelNav prev={4} next={6} label="06 / 08 — TROPHIES" onNav={onNav} />
      </section>

      {/* ── Signal Boost Modal — triggered by unlocked trophy click ── */}
      {modalOpen && (
        <SignalBoostModal
          onClose={() => setModalOpen(false)}
          broadcasts={broadcasts}
          drivers={drivers}
        />
      )}
    </>
  );
}